export default __webpack_public_path__ + "728c7283222a49d04651adbdfc814772.svg";